export const TYPOGRAPHY_WEIGHT = {
  BOLD: 'bold',
  NORMAL: 'normal',
  LIGHT: 'light',
} as const;

export type TypographyWeight = (typeof TYPOGRAPHY_WEIGHT)[keyof typeof TYPOGRAPHY_WEIGHT];
